import React from 'react';
import { Switch } from 'new/elements/Switch';

import styles from './OrgPersonalToggle.module.scss';

export const OrgPersonalToggle = (props: { checked: boolean; onChange: () => void }) => {
  return (
    <div className={styles.container}>
      <span className={styles.text}>Mine</span>
      <Switch checked={props.checked} onChange={props.onChange} />
      <span className={styles.text}>Org</span>
    </div>
  );
};
